import React from "react";
import {withTranslation} from "react-i18next";
import {
    ArrowRightOutlined,LeftOutlined
} from '@ant-design/icons';
import "../cervo.scss";
import {Button} from 'antd';
import {history} from '_helpers/history'

import luxs from "assets/img/luxdedo.png";
import Headerbutton from "../../../component/headerButton";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";

function stepCervoThree(props) {
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t} =props;

    const saveAndContinue = () => {
        history.push("/admin/assessment")
    }
    return (

      <div className={"containerStartCervoTwo wrapper history"}>
          <div className={"insideCeiba boxed"}>
              <Headerbutton  saveAndContinue={saveAndContinue}  />
          </div>
          <div className={"container-history boxed"}>
              <img className={"character character--flip character--lux"} src={luxs} alt={""} />
              <div className={"container-dialogue"}>
                  <div className={"dialogue-content-text"}>
                      <p className={"dialogue-text"} dangerouslySetInnerHTML={{__html: t('cervo.misioncervo')}}></p>
                      <p className={"dialogue-text"} dangerouslySetInnerHTML={{__html: t('cervo.misioncervo2')}}></p>
                  </div>
                  <div className={"dialogue-buttons"}>
                      <div className="left margin-right-auto">
                          <Button
                            icon={<LeftOutlined />}
                            type={"link"}
                            onClick={() => props.goTo(3)}
                          >
                              {t("atras")}
                          </Button>
                      </div>
                      <div className="right">
                          <Button icon={<ArrowRightOutlined />}
                                  onClick={() => props.goTo(5)}
                                  type={"primary"}
                                  className="primaryButton"
                          >
                              {t("cervo.entrar")}
                          </Button>
                      </div>
                  </div>
                  <p className={"dialogue-name"}>
                      <strong>LUX</strong>
                  </p>
              </div>
          </div>
      </div>

    )
}

export default withTranslation()(stepCervoThree);
